import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Image, Space } from 'antd';
import { ButtonGroup, Button } from '@mui/material';
import { WindowRounded, ViewModuleRounded, ViewCompactRounded, AppsRounded, FileCopyRounded } from "@mui/icons-material";
import CopyText from "../../Components/Text/CopyText";

const mapSizeToDimensions = (size) => {
    switch (size) {
        case 'lg':
            return [180, 180];
        case 'md':
            return [140, 140];
        case 'sm':
            return [100, 100];
        default:
            return [140, 140];
    }
}

const SizeIcon = ({ size }) => (
    size === 'lg' ? <WindowRounded /> :
        size === 'md' ? <ViewModuleRounded /> :
            size === 'sm' ? <AppsRounded /> :
                null
);

const ImageGrid = ({ imageUrls, sizes = ['lg', 'md', 'sm'], gridGutter = [64, 64] }) => {
    const [thumbnailSize, setThumbnailSize] = useState(sizes[0]);
    const [imageWidth, imageHeight] = mapSizeToDimensions(thumbnailSize);

    if (!imageUrls || imageUrls.length === 0) {
        return;
    }

    return (
        <Card bordered={false}
            title={
                <ButtonGroup variant="outlined">
                    {sizes.map(size => (
                        <Button
                            startIcon={<SizeIcon size={size}/>}
                            key={size}
                            onClick={() => setThumbnailSize(size)}
                            variant={thumbnailSize === size ? 'contained' : 'outlined'}
                            color={thumbnailSize === size ? 'info' : 'primary'}
                        >
                            {size === 'lg' ? 'Large' :
                                size === 'md' ? 'Medium' :
                                    'Small'}
                        </Button>
                    ))}
                </ButtonGroup>
            }
        >
            <Row justify={'center'} gutter={gridGutter}>
                {imageUrls.map((url, index) => (
                    <Col key={index} style={{ marginBottom: gridGutter }}>
                        <Card
                            className={'gapless'}
                            hoverable
                            bordered={false}
                            style={{ width: imageWidth, height: imageHeight, overflow: 'hidden' }}
                            bodyStyle={{ padding: 0 }}
                            cover={
                                <Image src={url} width={imageWidth} height={imageHeight} />
                            }
                        />
                        <Space>
                            <CopyText style={{ color: "#C5D6E5" }} text={url} />
                        </Space>
                    </Col>
                ))}
            </Row>
        </Card>
    );
};

export default ImageGrid;